import { Card } from 'react-bootstrap'
import { Ico35 } from "@icons/new"
//import { Trans } from '@lib/i18n'

const KeyindicatorsTable4 = () => {
  

  return (
  <Card className="cards-utente d-none d-md-block card-table w-100">
    <Card.Body>
      <Ico35 className="logo-card ico-box-blue" />
     {/* <Card.Title><Trans code="A0183" /></Card.Title>*/}
      <div style={{ overflowX: 'scroll'}} className="w-100">
        <table className="investment-table mt-3">
          <thead>
            <tr>
              <th className="">Energia</th>
              <th></th>
              <th>Value</th>
              <th className="">Theme</th>
              <th className="">R</th>
              <th>Scale</th>
              <th className="">Sources</th>
              <th className="">Update</th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <td>Produzione primaria di energia elettrica</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
            <tr>
              <td>Gen. di elettricità: % di rinnovabile</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
            <tr>
              <td>Gen. di energia elettrica: % di rinnovabili escl. idro</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
            <tr>
              <td>Consumo di elettricità (annuale pro capite)</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
            <tr>
              <td>Produzione di petrolio (annuale)</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
            <tr>
              <td>Riserve di petrolio (annuali)</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
            <tr>
              <td>Produzione di gas naturale (annuale)</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
            <tr>
              <td>Riserve di gas</td>
              <td>2.52</td>
              <td>M EUR</td>
              <td>2343</td>
              <td>4224</td>
              <td>erferf</td>
              <td>Openeconomics</td>
              <td>14/05/2021</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="va-desc"></p>
    </Card.Body>
  </Card>
  );
}

export default KeyindicatorsTable4;